export function generateDuplicateTitle(originalTitle) {
  if (!originalTitle) return ''

  const copyRegex = /^(.+?)\s*\((\d+)\)$/
  const match = originalTitle.match(copyRegex)

  if (match) {
    const baseTitle = match[1]
    const copyNumber = parseInt(match[2]) + 1
    return `${baseTitle} (${copyNumber})`
  } else {
    return `${originalTitle} (1)`
  }
}
